import React, { useState, useEffect } from "react";
import Select from "../common/Select";
import FosterHomeButtonBar from "./FosterHomeButtonBar";
import { getBintiHomesByStatus } from "../services/soar";

function Homes(props) {
  const [selectedState, setSelectedState] = useState("");
  const [homes, setHomes] = useState([]);
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));

  useEffect(() => {
    if (
      safyInfo?.user &&
      safyInfo.user.safyInfo.BusinessUnitIdName !== "ccplive"
    )
      setSelectedState(
        safyInfo.user.safyInfo.BusinessUnitIdName.toLowerCase()
          .replace("safy of ", "")
          .replace(" ", "")
      );
  }, [safyInfo]);

  useEffect(() => {
    if (selectedState !== "") {
      //setLoading(true);
      setHomes([]);
      //setRefreshData(false);
      getBintiHomesByStatus(selectedState, "closed").then((response) => {
        if (response && response !== "") {
          const allApps = JSON.parse(response);
          allApps.sort((a, b) =>
            a.HomeData[0].createdon < b.HomeData[0].createdon ? 1 : -1
          );
          setHomes(allApps);
        }
        //setLoading(false);
      });
      //call available tags
      // getAvailableBintiTags(selectedState).then((response) => {
      //   if (response && response !== "") {
      //     const allTags = JSON.parse(response).tags;
      //     //console.log("TAGS", allTags);
      //     const tags = allTags.map((t) => t.tag);
      //     setAvailableTags(tags);
      //   }
      // });
    }
  }, [selectedState]);

  return (
    <div>
      <div className="h5">Homes</div>
      {process.env.REACT_APP_ENVIRONMENT !== "Production" && (
        <div className="bg-danger text-white my-4 p-4">
          THIS PROTOTYPE IS CONNECTED TO LIVE BINTI DATA <br />
          This module is currently under development and is for testing READING
          permissions between Binti and SOAR data. This has connections to the
          Live Binti system. Please do not add/modify any information at this
          time.
        </div>
      )}
      {JSON.stringify(safyInfo.user.safyInfo.binti) === "[{}]" ? (
        <div className="bg-danger text-white my-4 p-4">
          User does not have any Binti Worker ID. Case Note creation will be
          restricted
        </div>
      ) : null}
      {safyInfo.user.safyInfo.BusinessUnitIdName === "ccplive" ||
      safyInfo.user.modules.includes("Admin") ? (
        <div className="rounded bg-warning p-2 mb-4">
          <Select
            className="col-6"
            name="stateSelection"
            label="Select State"
            onChange={(e) => {
              //setLoading(true);
              setSelectedState(e.currentTarget.value);
            }}
            options={[
              { name: "Alabama", _id: "alabama" },
              { name: "Colorado", _id: "colorado" },
              { name: "Indiana", _id: "indiana" },
              { name: "Kentucky", _id: "kentucky" },
              { name: "Nevada", _id: "nevada" },
              { name: "Ohio", _id: "ohio" },
              { name: "South Carolina", _id: "southcarolina" },
            ]}
            value={selectedState}
          ></Select>
        </div>
      ) : null}
      {homes.map((home) => {
        return <FosterHomeButtonBar key={home.id} home={home} n />;
      })}
    </div>
  );
}

export default Homes;

//Phone xxx
//Email xxxx
//Link to Binti
//Status xxx
//Placement Characteristics
//Genders
//Ages
//Licensing
//Active License
//Capacity
//Beds xxx
//Forms
//FH ID
//Sage
//Binti
//Members
